export const getAuthToken = () => {
	try {
		const serializedToken = localStorage.getItem('ls.monitoringAuth');
		if (serializedToken === null) {
			return null;
		}
		return JSON.parse(serializedToken);
	} catch (err) {
		return null;
	}
};

export const setAuthToken = token => {
	localStorage.setItem('ls.monitoringAuth', JSON.stringify(token));
};

export const removeAuthToken = () => {
	localStorage.removeItem('ls.monitoringAuth');
};

export const addRecentSearch = searchString => {
	const trimmedString = searchString.trim();
	let currentRecentSearches = JSON.parse(localStorage.getItem('monitoring.recentSearches'));
	if (!currentRecentSearches) {
		currentRecentSearches = [];
	}

	// don't handle if the string already is saved
	if (currentRecentSearches.indexOf(trimmedString) !== -1) {
		return;
	}

	const updatedRecentSearches = [trimmedString, ...currentRecentSearches];

	if (currentRecentSearches.length > 4) {
		updatedRecentSearches.pop();
	}

	localStorage.setItem('monitoring.recentSearches', JSON.stringify(updatedRecentSearches));
};

export const getRecentSearches = () => JSON.parse(localStorage.getItem('monitoring.recentSearches'));

export const setQueryEditorTheme = theme => {
	localStorage.setItem('monitoring.queryEditorTheme', JSON.stringify(theme));
};

export const getQueryEditorTheme = () => JSON.parse(localStorage.getItem('monitoring.queryEditorTheme'));

export default '';
